import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const InfoPopup = /*#__PURE__*/ React.forwardRef(({ as: Tag = "div", tooltip, variant, placement, ...props }, ref)=>{
    const overlay = (overlayProps)=>/*#__PURE__*/ React.createElement(Tooltip, {
            ...overlayProps,
            className: variant ? `tooltip-${variant}` : undefined
        }, tooltip);
    if (!tooltip) {
        return /*#__PURE__*/ React.createElement(Tag, {
            ef: ref,
            ...props
        });
    }
    return /*#__PURE__*/ React.createElement(OverlayTrigger, {
        overlay: overlay,
        placement: placement
    }, /*#__PURE__*/ React.createElement(Tag, {
        ref: ref,
        ...props
    }));
});

export { InfoPopup };
//# sourceMappingURL=InfoPopup.js.map
